import classnames from 'classnames'
import * as React from 'react'

import { shortFormatNumber } from '../../../../util'
import { ManagerFundItemData } from '../../constants'
import { TickerButton } from '../TickerButton'

type Props = Pick<ManagerFundItemData, 'topInvestments'>

export function ManagerHoldingsSection({ topInvestments }: Props) {
  const tickerRows = React.useMemo(() => {
    const rows: Props['topInvestments'][] = []
    topInvestments.forEach((investment) => {
      const lastRow = rows[rows.length - 1]
      if (!lastRow || lastRow.length > 1) {
        rows.push([])
      }
      rows[rows.length - 1].push(investment)
    })
    return rows
  }, [topInvestments])
  const hasHoldings = tickerRows.length > 0

  return (
    <div className={classnames('min-h-24', { 'flex items-center justify-center': !hasHoldings })}>
      {!hasHoldings && (
        <span className="text-2xs text-muted-2">No portfolio holdings have been reported in the last quarter.</span>
      )}
      {tickerRows.map((rowInvestments, i) => (
        <div className="flex flex-wrap items-center justify-between gap-2" key={i}>
          {rowInvestments.map(
            ({ ticker, name, boxoverData, percentageOfPortfolio, value, putCall }, investmentIndex) => (
              <div className="grid h-6 max-w-48 flex-1 grid-cols-3 items-center" key={investmentIndex}>
                <div className="flex justify-start">
                  <TickerButton
                    className="min-w-12.5 flex-1 text-2xs xl:flex-none"
                    ticker={ticker}
                    name={name}
                    putCall={putCall}
                    boxoverData={boxoverData}
                  />
                </div>
                <span className="w-16 px-1 text-right text-2xs">
                  {shortFormatNumber(percentageOfPortfolio, { defaultValue: '—' })}
                  {Number.isFinite(percentageOfPortfolio) ? '%' : ''}
                </span>
                <span className="w-17 px-1 text-right text-2xs">{shortFormatNumber(value, { defaultValue: '—' })}</span>
              </div>
            )
          )}
        </div>
      ))}
    </div>
  )
}
